import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: "app-adminnextsys-manage-service-stb-detail",
  templateUrl: "./adminnextsys-manage-service-stb-detail.component.html",
  styleUrls: ["./adminnextsys-manage-service.component.css"],
})
export class AdminNextsysManageServiceSTBDetailComponent implements OnInit {

  permision: string[] = [];
  currentuser: any = {};
  allowed = true;
  flagging: any = {};

  ViewCustomer: any = [];
  ViewCustomeratvorder: any = [];
  listservices: any = [];
  liststb: any = [];
  liststbcust: any = [];
  data_products: any = [];

  btnchange = false;
  showuserinfo = false;
  openInfoUser = false;
  alert_success = false;
  alert_failed = false;

  showin = true;

  alert_act = '';

  formCust = this.fb.group({
    nama: [''],
    nik: [''],
    tlp: [''],
    tlp2: [''],
    email: [''],
    email2: [''],
    alamat: [''],
    kota: [''],
    partnername: [''],
    notes: [''],
  })

  formChange = this.fb.group({
    nama: [''],
    id: [''],
    billingtype: [''],
    notes: [''],
  })

  formLayanan = this.fb.group({
    id: [''],
  })

  subservices: any = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public LoadJsOrder: LoadJsService,
    private fb: FormBuilder,
    public partnerService: ApiPartnerService,
    private Auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.permision = this.currentuser.permision;
    this.loadStart();
    this.fetchProductSales();
    this.setflag('atvinfo', 'open', true);
  }

  fetchProductSales() {
    return this.partnerService.PostListProduct({ productsource: 5 }).subscribe((output: any) => {
      this.data_products = output.data;
    })
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('idstb');
    // alert(id);
    this.loadCustomer(id);
  }

  viewdataorder(datatype, val) {

    if (this.ViewCustomeratvorder[datatype] == undefined) {
      return '--';
    } else {
      return this.ViewCustomeratvorder[datatype][val];
    }

  }

  onActionClick(act: any, item: any) {
    // console.log(item);
    this.alert_act = act;

    if (act == "update") {
      console.log(item)
    }
    else if (act == "changebilling") {
      console.log(item)

      this.showin = true

      this.formChange.get('nama').setValue(item.nama)
      this.formChange.get('id').setValue(item.id)
      this.formChange.get('billingtype').setValue(item.billingtype)
      this.formChange.get('notes').setValue('')

    }
  }

  btntoggle() {
    this.showin = false
  }

  loadCustomer(id: any) {
    this.setflag('view', 'loading', true);
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
      if (output.status == true) {
        this.setflag('view', 'allowed', true);
        this.ViewCustomer = output.data;
        this.listservices = output.data.services;
        this.liststb = output.data.stb;
        this.liststbcust = output.data.stbcust;
        console.log("liststbcust: ", JSON.stringify(this.ViewCustomer));
        this.loadServices(id);
      } else {
        this.setflag('view', 'allowed', false);
      }
      this.setflag('view', 'loading', false);
    })
  }

  loadServices(id: any) {

    this.partnerService.GetCustomerService('?id=' + id).subscribe((output: any) => {
      //console.log(output);
      this.listservices = output.data;
    })
  }

  submitUpdate(item: any) {
    return this.partnerService.updatecustomer(item.id, this.formCust.value).subscribe((output: any) => {
      // console.log(output.data)

      // console.log('masuk', this.formCust.value.nama)
      if (output.status) {

        this.ngOnInit()
        console.log("masuk")

        this.LoadJsOrder.loadScriptProductStb()

        this.alert_success = true

        setTimeout(() => {
          this.alert_success = false
        }, 6000);

      } else {
        console.log("gagal")

        this.LoadJsOrder.loadScriptProductStb()
        this.alert_failed = true

        setTimeout(() => {
          this.alert_failed = false
        }, 6000);
      }

    })
  }

  submitSetLayanan(item: any) {
    this.postService();
  }

  submitChange(item: any) {

    console.log(item)

    return this.partnerService.Changebillingcust(item.id, this.formChange.value).subscribe((output: any) => {
      if (output.status) {

        this.ngOnInit()
        console.log("masuk")

        this.LoadJsOrder.loadScriptProductStb()

        this.alert_success = true

        setTimeout(() => {
          this.alert_success = false
        }, 6000);

      } else {
        console.log("gagal")

        this.LoadJsOrder.loadScriptProductStb()
        this.alert_failed = true

        setTimeout(() => {
          this.alert_failed = false
        }, 6000);
      }

    })
  }

  setflag(id, key, val) {
    console.log(id, key, val);
    if (this.flagging[id] == undefined) {
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if (this.flagging[id][key] == undefined) {
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    console.log(this.flagging[id]);
  }

  flag(id, key) {
    if (this.flagging[id] == undefined) {
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    } else if (this.flagging[id][key] == undefined) {
      this.flagging[id][key] = false;
    }

    //    console.log(this.flagging[id]);
    //    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

  postService() {
    const selectedValue = this.formLayanan.value.id;
    const selectedArray = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
    const selectedOrderIds = selectedArray
      .filter(v => v && v !== '')
      .map(v => ({ "productsale_id": v }));

    let id = this.route.snapshot.paramMap.get('id');
    let data = {customer_id : this.ViewCustomer.id, services :  JSON.stringify(selectedOrderIds) };
    console.log('id:', id);
    console.log('data:', data);
    console.log('selectedOrderIds:', selectedOrderIds);
    return this.partnerService.PostServiceNextsys(data).subscribe((output: any) => {
      if (output.status) {
        this.ngOnInit()
        this.alert_success = true
        this.alert_failed = false
      } else {
        this.alert_success = false
        this.alert_failed = true
      }
    })
  }

}
